import React from 'react';
import { useRef } from 'react';
import PropTypes from 'prop-types';
import * as Yup from 'yup';
import { Formik, Form, Field } from 'formik';

import i18n from 'i18n-js';
import Box from '@material-ui/core/Box';
import { BaseModal } from 'components/UI';
import { RadioButton, RadioButtonsGroup } from 'components/FormFields';

const ChooseNFCBrokerModal = ({
  broker,
  availablesBrokers,
  open,
  handleClick,
  handleBrokerSelection,
}) => {
  const formRef = useRef(null);

  const NFCCardSchema = Yup.object().shape({
    broker: Yup.string().required(i18n.t('common.required_field')),
  });

  const onSubmit = (values) => {
    handleBrokerSelection(values.broker);
    handleClick();
  };

  const handleSubmit = () => {
    formRef.current.submitForm();
  };

  const handleCancel = () => {
    handleClick();
  };

  const handleClose = () => {
    handleClick();
  };

  const initialValues = {
    broker: broker,
  };

  return (
    <BaseModal
      size="sm"
      open={open}
      maxWidth={550}
      hasEnterButton
      hasCancelButton
      onEnter={handleSubmit}
      onCancel={handleCancel}
      enableCloseButton={false}
      handleClick={handleClose}
      title={i18n.t('nfc.select_broker')}
      enterButtonLabel={i18n.t('common.continue')}
      data-cy="nfc-select-broker"
    >
      <Formik
        enableReinitialize
        innerRef={formRef}
        onSubmit={onSubmit}
        initialValues={initialValues}
        validationSchema={NFCCardSchema}
      >
        {({ handleSubmit, values, errors, touched, setFieldValue }) => (
          <Form noValidate onSubmit={handleSubmit}>
            <p>{i18n.t('nfc.select_broker_description')}</p>
            <Box mt={1}>
              <RadioButtonsGroup
                nonBool
                errors={errors}
                touched={touched}
                name="broker"
                value={values.broker}
                setFieldValue={setFieldValue}
              >
                {availablesBrokers.map((broker) => (
                  <Field
                    key={broker.org_to_broker_id}
                    value={broker.broker_slug}
                    component={RadioButton}
                    label={broker.name.charAt(0).toUpperCase() + broker.name.slice(1).toLowerCase()}
                  />
                ))}
              </RadioButtonsGroup>
            </Box>
          </Form>
        )}
      </Formik>
    </BaseModal>
  );
};

ChooseNFCBrokerModal.propTypes = {
  broker: PropTypes.object,
  availablesBrokers: PropTypes.array,
  open: PropTypes.bool,
  handleClick: PropTypes.func,
  handleBrokerSelection: PropTypes.func,
};

export default ChooseNFCBrokerModal;
